import Grid from '@material-ui/core/Grid';
import React, { useState } from 'react';
import { MyChartData } from '../../../charts/MyChartData';
import { MyChartDataTable } from '../../../charts/MyChartDataTable';
import { PieChart } from '../../../charts/PieChart';
import { useAppContext } from '../../../components/appContext/app-provider';
import { SwitchBlueGreen } from '../../../components/Switch';
import { Venda, VendaMedidas } from '../../../models/venda';
import { DashPanel } from '../DashPanel';

export interface PanelTicketMedioCombustiveisProps {
  vendaCombustiveis: Venda[];
  comparativo?: Venda[];
  totaisCombustiveis: VendaMedidas;
  totaisComparativo?: VendaMedidas;
  colorArray: string[];
}

export const PanelTicketMedioCombustiveis = (props: PanelTicketMedioCombustiveisProps) => {
  const [checkedPorQtd, setCheckedPorQtd] = useState(true);
  const context = useAppContext();

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedPorQtd(event.target.checked);
  }

  const getValorComparativo = (sigla: string) => {
    const itemComparativo = props.comparativo?.find(c => c.sigla === sigla);

    return itemComparativo ? (checkedPorQtd === true ? itemComparativo.mediaQuantidade : itemComparativo.mediaLiquida) : undefined;
  }

  var dadosChart: MyChartData[] = [];
  var dadosLista: MyChartData[] = [];
  if (checkedPorQtd === true) {
    dadosChart = props.vendaCombustiveis.map(x => ({ sigla: x.sigla!, name: x.nome, value: x.mediaQuantidade, compareValue: getValorComparativo(x.sigla!) }));
    dadosLista = dadosLista.concat(dadosChart);
    dadosLista.unshift({ sigla: 'T', name: 'Total', value: props.totaisCombustiveis.mediaQuantidade, compareValue: props.totaisComparativo?.mediaQuantidade || undefined });
  }
  else {
    dadosChart = props.vendaCombustiveis.map(x => ({ sigla: x.sigla!, name: x.nome, value: x.mediaLiquida, compareValue: getValorComparativo(x.sigla!) }));
    dadosLista = dadosLista.concat(dadosChart);
    dadosLista.unshift({ sigla: 'T', name: 'Total', value: props.totaisCombustiveis.mediaLiquida, compareValue: props.totaisComparativo?.mediaLiquida || undefined });
  }

  return <DashPanel
    title="Ticket Médio"
    headerAction={
      <div>
        <Grid component="label" container alignItems="center" spacing={1}>
          <Grid item>R$</Grid>
          <Grid item>
            <SwitchBlueGreen checked={checkedPorQtd} onChange={handleSwitchChange} name="switchTicketMedioCombustiveis" />
          </Grid>
          <Grid item>(L)</Grid>
        </Grid>
      </div>
    }
  >
    <div style={{ paddingBottom: '8px' }}>
      <PieChart
        dados={dadosChart}
        showLegend={false}
        colorArray={props.colorArray}
      />
    </div>
    <MyChartDataTable rows={dadosLista} format="0.00" avatarSize="small" displayName={false} dataCompareValue={context.model.filtroModel?.comparableDateFilter} />
  </DashPanel>;
}
